"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkPriceWebSocket = void 0;
const rxjs_1 = require("rxjs");
const CacheData_1 = require("./base/CacheData");
const SubsPairMgr_1 = require("./base/SubsPairMgr");
const BaseWebSocket_1 = require("./BaseWebSocket");
const QuotationSocketMgr_1 = require("./QuotationSocketMgr");
class MarkPriceWebSocket extends BaseWebSocket_1.BaseWebSocket {
    constructor() {
        super(...arguments);
        this.markPriceCacheData = new CacheData_1.CacheData(new Map(), new rxjs_1.BehaviorSubject(new Map()));
        this.markPricePairPoolMgr = new SubsPairMgr_1.SubsPairMgr(QuotationSocketMgr_1.SubscribeEventType.markPrice, (type, param) => {
            return this.send(QuotationSocketMgr_1.SubscribeEventType.markPrice, param);
        });
    }
    handleMarkPriceData(pushData) {
        if (pushData && pushData.length) {
            const result = new Map();
            pushData
                .map((data) => {
                return {
                    exchange: data.e,
                    base: data.b,
                    quote: data.q,
                    price: data.p,
                    index: data.i,
                    rate: data.r,
                };
            })
                .forEach((item) => {
                const identify = `${item.base}/${item.quote}`;
                result.set(identify, item);
            });
            this.markPriceCacheData.getDataSubject().next(result);
        }
    }
    /**
     * 订阅Mark price推送
     * [{
     *    exchange: "pionex.v2",
     *    base: base,
     *    quote: quote,
     * }]
     * @param exchange
     * @param base
     * @param quote
     */
    getMarkPriceObservable(exchange, base, quote) {
        this.markPricePairPoolMgr.addSubscribePair([{ market: exchange, base: base, quote: quote }]);
        return new rxjs_1.Observable((observer) => {
            const subscription = this.markPriceCacheData.getDataSubject().subscribe((result) => {
                const ticker = result.get(`${base}/${quote}`);
                observer.next(ticker);
            }, (err) => { });
            observer.add(() => {
                subscription.unsubscribe();
                this.markPricePairPoolMgr.removeSubscribePair([
                    {
                        market: exchange,
                        base: base,
                        quote: quote,
                    },
                ]);
            });
        });
    }
    /**
     *
     * @param pairInfoList
     */
    getMarkPriceObservableBatch(pairInfoList) {
        this.markPricePairPoolMgr.addSubscribePair(pairInfoList);
        return new rxjs_1.Observable((observer) => {
            const subscription = this.markPriceCacheData.getDataSubject().subscribe((result) => {
                const filterResult = [];
                pairInfoList.forEach((pairInfo) => {
                    const ticker = result.get(`${pairInfo.base}/${pairInfo.quote}`);
                    if (ticker) {
                        filterResult.push(ticker);
                    }
                });
                observer.next(filterResult);
            }, (err) => { });
            observer.add(() => {
                subscription.unsubscribe();
                this.markPricePairPoolMgr.removeSubscribePair(pairInfoList);
            });
        });
    }
}
exports.MarkPriceWebSocket = MarkPriceWebSocket;
